  const buttons = document.querySelectorAll('.accordion-button');
  buttons.forEach(button => {
    button.addEventListener('click', () => {
      const isActive = button.classList.contains('active');
      buttons.forEach(b => {
        b.classList.remove('active');
        b.nextElementSibling.classList.remove('open');
      });
      if (!isActive) {
        button.classList.add('active');
        button.nextElementSibling.classList.add('open');
      }
    });
  });